import ApiService from "../common/api.service";
import {
  GET_ACTIVE_USERS_OVERVIEW,
  GET_ACTIVITY_RESULTS,
  GET_SKILLGAMES_USAGE,
  GET_SKILLGAMES_PERCENTAGE_USAGE,
  GET_USER_COURTS,
  GET_USER_OVERVIEW
} from "./actions.type";
import {
  SET_TOTAL_ACTIVE_USERS,
  SET_TOTAL_ACTIVITY_PER_AGE,
  SET_ACTIVITY_RESULTS,
  SET_SKILLGAMES_SINGLE_USAGE,
  SET_SKILLGAMES_MULTI_USAGE,
  SET_SKILLGAMES_PERCENTAGE_USAGE,
  SET_USER_COURTS,
  SET_SELECTED_COURT,
  SET_USER_OVERVIEW
} from "./mutations.type";

const state = {
  totalActiveUsers: 0,
  ageOfUsersChartDataset: null,
  activityResults: [],
  skillgameSingleUsage: [],
  skillgameMultiUsage: [],
  skillgamePercentageUsage: null,
  averageStatistics: null,
  usersTableDataset: null,
  userCourts: null,
  selectedCourt: {},
  usersOverview: {}
};

const getters = {
  getTotalActiveUsers: state => state.totalActiveUsers,
  getAgeOfUsersChartDataset: state => state.ageOfUsersChartDataset,
  getActivityResults: state => state.activityResults,
  getSkillgamesSingleUsage: state => state.skillgameSingleUsage,
  getSkillgamesMultiUsage: state => state.skillgameMultiUsage,
  getSkillgamePercentageUsage: state => state.skillgamePercentageUsage,
  getAverageStatistics: state => state.averageStatistics,
  getUsersTableDataset: state => state.usersTableDataset,
  getUserCourts: state => state.userCourts,
  getSelectedCourt: state => state.selectedCourt,
  getUsersOverview: state => state.usersOverview
};

const actions = {
  async [GET_ACTIVE_USERS_OVERVIEW]({ commit }, payload) {
    ApiService.get(
      `dashboard/courts/${payload.courtId}/users/active-users-overview/${payload.time}`
    ).then(response => {
      let tempAge = [
        response.data.under_12_percentage.toFixed(0),
        response.data.between_12_and_18_percentage.toFixed(0),
        response.data.between_18_and_25_percentage.toFixed(0),
        response.data.between_25_and_30_percentage.toFixed(0),
        response.data.between_30_and_40_percentage.toFixed(0),
        response.data.between_40_and_50_percentage.toFixed(0),
        response.data.over_50_percentage.toFixed(0)
      ];

      commit(SET_TOTAL_ACTIVE_USERS, response.data.total_active_users);
      commit(SET_TOTAL_ACTIVITY_PER_AGE, tempAge);
    });
  },

  async [GET_ACTIVITY_RESULTS]({ commit }, payload) {
    var tempAllRecords = [];
    let tempUnder12 = [];
    let tempBetween12And18 = [];
    let tempBetween18And25 = [];
    let tempBetween25And30 = [];
    let tempBetween30And40 = [];
    let tempBetween40And50 = [];
    let tempOver50 = [];
    await ApiService.get(
      `dashboard/courts/${payload.courtId}/users/activity-results/total`
    ).then(response => {
      response.data.map(data => {
        tempUnder12.push(data.under_12);
        tempBetween12And18.push(data.between_12_and_18);
        tempBetween18And25.push(data.between_18_and_25);
        tempBetween25And30.push(data.between_25_and_30);
        tempBetween30And40.push(data.between_30_and_40);
        tempBetween40And50.push(data.between_40_and_50);
        tempOver50.push(data.over_50);
      });

      tempAllRecords.push(tempUnder12);
      tempAllRecords.push(tempBetween12And18);
      tempAllRecords.push(tempBetween18And25);
      tempAllRecords.push(tempBetween25And30);
      tempAllRecords.push(tempBetween30And40);
      tempAllRecords.push(tempBetween40And50);
      tempAllRecords.push(tempOver50);
    });
    commit(SET_ACTIVITY_RESULTS, tempAllRecords);
  },
  async [GET_SKILLGAMES_USAGE]({ commit }, payload) {
    let tempSinglePlayer = [];
    let tempMultiPlayer = [];

    await ApiService.get(
      `dashboard/courts/${payload.courtId}/users/skillgames-usage-graph/total`
    ).then(response => {
      response.data.map(data => {
        if (
          data.hour == 0 ||
          data.hour == 3 ||
          data.hour == 6 ||
          data.hour == 9 ||
          data.hour == 12 ||
          data.hour == 15 ||
          data.hour == 18 ||
          data.hour == 21 ||
          data.hour == 23
        ) {
          tempSinglePlayer.push(data.singleplayer);
          tempMultiPlayer.push(data.multiplayer);
        }
      });
    });
    commit(SET_SKILLGAMES_SINGLE_USAGE, tempSinglePlayer);
    commit(SET_SKILLGAMES_MULTI_USAGE, tempMultiPlayer);
  },
  async [GET_SKILLGAMES_PERCENTAGE_USAGE]({ commit }, payload) {
    await ApiService.get(
      `dashboard/courts/${payload.courtId}/users/skillgames-usage-percentages/total`
    ).then(response => {
      let tempObj = {
        singlePlayer: response.data.singleplayer.toFixed(0),
        multiPlayer: response.data.multiplayer.toFixed(0)
      };
      commit(SET_SKILLGAMES_PERCENTAGE_USAGE, tempObj);
    });
  },

  async [GET_USER_OVERVIEW]({ commit }, payload) {
    await ApiService.get(
      `dashboard/courts/${payload.courtId}/users/users-overview/${payload.time}?page=${payload.page}`
    ).then(response => {
      let usersArray = [];
      response.data?.data?.map(data => {
        usersArray.push(data);
      });
      commit(SET_USER_OVERVIEW, response.data);
    });
  },

  async [GET_USER_COURTS]({ commit }) {
    await ApiService.get("users/me/courts")
      .then(response => {
        commit(SET_USER_COURTS, response.data.data);
        commit(SET_SELECTED_COURT, response.data.data[0]);
      })
      .catch(err => {
        alert("Error retrieving courts", err);
      });
  }
};

const mutations = {
  [SET_TOTAL_ACTIVE_USERS](state, payload) {
    state.totalActiveUsers = payload;
  },

  [SET_TOTAL_ACTIVITY_PER_AGE](state, payload) {
    state.ageOfUsersChartDataset = payload;
  },

  [SET_ACTIVITY_RESULTS](state, payload) {
    state.activityResults = payload;
  },
  [SET_SKILLGAMES_SINGLE_USAGE](state, payload) {
    state.skillgameSingleUsage.splice(0, 1, payload);
  },
  [SET_SKILLGAMES_MULTI_USAGE](state, payload) {
    state.skillgameMultiUsage.splice(0, 1, payload);
  },
  [SET_SKILLGAMES_PERCENTAGE_USAGE](state, payload) {
    state.skillgamePercentageUsage = payload;
  },

  [SET_USER_OVERVIEW](state, payload) {
    state.usersOverview = payload;
  },

  [SET_USER_COURTS](state, payload) {
    state.userCourts = payload;
  },
  [SET_SELECTED_COURT](state, payload) {
    state.selectedCourt = payload;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
